import {find as _find} from 'lodash';
import {labels, currentResource} from '../../util/utils';
import {gaScopes as GAScopes} from '../../util/uiconstants';

export default (scopes) => {
	const gaScopes = [
		Number(GAScopes.full),
		Number(GAScopes.specific),
		Number(GAScopes.specificAuditProcedures),
		Number(GAScopes.review)
	];

	gaScopes.forEach((x) => {
		if (
			!scopes.some((y) => y.gaScopeTypeID === x && !y.isSubScope) &&
			scopes.some((z) => z.gaScopeTypeID === x && z.isSubScope)
		) {
			scopes.push({
				gaScopeID: null,
				isSubScope: false,
				gaScopeTypeID: x,
				gaParentScopeID: null,
				teamsCount: 0,
				instructionsCount: 0,
				groupTasksCount: 0,
				lastPublishedDate: null
			});
		}
	});

	return scopes
		.filter(({isSubScope}) => !isSubScope)
		.map(
			({
				gaScopeID: id,
				gaScopeTypeID: type,
				teamsCount: assignedTeamsCount,
				instructionsCount,
				groupTasksCount: tasksCount,
				lastPublishedDate: lastPublished
			}) => ({
				id,
				type,
				label: type > 0 ? _find(currentResource.gaScopesResource, {id: type}).label : labels.isReferenceOnly,
				assignedTeamsCount,
				instructionsCount,
				tasksCount,
				lastPublished,
				teamData: null,
				instructionData: null,
				taskData: null,
				subScopes: scopes
					.filter(({isSubScope, gaScopeTypeID: subScopeType}) => subScopeType === type && isSubScope)
					.map(
						({
							gaScopeID,
							gaScopeName,
							gaScopeTypeID,
							gaScopeDescription,
							teamsCount: assignedTeamsCount,
							instructionsCount,
							groupTasksCount: tasksCount,
							lastPublishedDate: lastPublished
						}) => ({
							id: gaScopeID,
							type: gaScopeTypeID,
							label: gaScopeName,
							description: gaScopeDescription,
							assignedTeamsCount,
							instructionsCount,
							tasksCount,
							lastPublished,
							teamData: null,
							instructionData: null,
							taskData: null
						})
					)
					.sort((a, b) => a.label.localeCompare(b.label))
			})
		)
		.sort((a, b) => {
			if (a.type === 0) return 5 - b.type;
			if (b.type === 0) return a.type - 5;

			return a.type - b.type;
		});
};
